import { Button, ButtonRounded, Modal } from '@components/atoms'
import { MenuItemType } from '@utils/types'
import { useTrans } from '../../../hooks'
import { Close } from '../../icons'
import styles from './ModalNoResult.module.sass'

interface Props {
  item: MenuItemType
  className?: string
  isOpen?: boolean
  setIsOpen?: (v: boolean) => void
}

const ModalNoResult = (props: Props) => {
  const { item = undefined, className = '', isOpen = false, setIsOpen = () => undefined } = props

  const t = useTrans()

  return item ? (
    <Modal
      id="modal-no-result"
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className={styles.modal}
    >
      <div className={styles.layout}>
        <ButtonRounded
          className={styles.icon}
          onClick={() => setIsOpen(false)}
          icon={<Close />}
          theme="neutral20"
          size="xs"
        />
        {/* <button className={styles.icon} onClick={() => setIsOpen(false)}>
          <Close />
        </button> */}
        <div className={styles.content}>
          <h3 className={styles.title}>{t('Non abbiamo trovato risultati per la tua ricerca')}</h3>
          <div
            className={styles.description}
            dangerouslySetInnerHTML={{ __html: item.description }}
          />
          <Button
            label={t('Chiudi')}
            size="lg"
            variant="primary"
            onClick={() => setIsOpen(false)}
            className={styles.button}
          />
        </div>
      </div>
    </Modal>
  ) : (
    <></>
  )
}

export default ModalNoResult
